import { makeStyles } from '@mui/styles';
const modalWithHeaderStyles = makeStyles(theme => ({
    modalRoot: {
        borderRadius: 'unset',
        [theme.breakpoints.down('sm')]: {
            minWidth: '60vw',
        },
        width: '100%',
        [theme.breakpoints.up('md')]: {
            maxWidth: '600px',
        },
    },
    closeContainer: {
        color: theme.palette.common.white,
        zIndex: 100,
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        justifyContent: 'space-between',
        padding: 0,
        alignItems: 'center',
    },
    closeIcon: {
        width: 40,
        height: 40,
        fill: theme.palette.primary.main,
    },
    closeButton: {
        height: '27px',
        width: '27px',
        cursor: 'pointer',
        textAlign: 'right',
        margin: '8px',
    },
    title: {
        lineHeight: '33px',
        display: 'inline-block',
        padding: '16px',
        color: theme.palette.primary.main,
        fontWeight: 'bold',
    },
    icon: {
        width: '100%',
        height: '100%',
        fill: theme.palette.primary.main,
    },
    content: {
        whiteSpace: 'pre-wrap',
        overflowY: 'auto',
        height: '350px',
    },
    actionsContainer: {
        justifyContent: 'center',
    },
}), { name: 'Common_ModalWithHeader' });
export default modalWithHeaderStyles;
//# sourceMappingURL=modalWithHeader.styles.js.map